import React from 'react'

// Hooks
import { useGlobal } from '../../../../../hooks'

import { AdministrationList } from '../../../List'

// Queries
import { DELETE_PROCEDURES, LIST_PROCEDURES } from './queries'

const queries = {
  list: LIST_PROCEDURES,
  delete: DELETE_PROCEDURES,
}

const AdministrationListSamplingProcedures = () => {
  const [{ me }] = useGlobal()

  const no = ![1, 2].includes(me.id_role)

  return (
    <AdministrationList
      queries={queries}
      noCreate={no}
      noUpdate={no}
      noDelete={no}
    />
  )
}

export default AdministrationListSamplingProcedures
